import React from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from 'react-i18next';


const SettingsDropdown: React.FC = () => {
  const { t, i18n } = useTranslation(); 
  return (
    <Dropdown>
      <Dropdown.Toggle variant="" id="dropdown-basic" className="w-100 d-flex justify-content-end align-items-center">
      <i className="bi bi-gear-fill me-2 fs-4"></i>        
        <span>{t('settings')}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu style={{ zIndex: 9999 }}>
        <Dropdown.Item href="/settings">{t('settings')}</Dropdown.Item>
        <Dropdown.Item href="/settings/company-department" disabled>{t('companyDepartment')}</Dropdown.Item>
        <Dropdown.Item href="/settings/users" disabled>{t('users')}</Dropdown.Item>
        <Dropdown.Item href="/settings/categories" disabled>{t('categoriesOfIncome')}</Dropdown.Item>
        <Dropdown.Item href="/settings/activity" disabled>{t('activity')}</Dropdown.Item>
        <Dropdown.Item href="/settings/api" disabled>{t('api')}</Dropdown.Item>
        <Dropdown.Item href="/settings/import" disabled>{t('import')}</Dropdown.Item>
        <Dropdown.Item href="/settings/account-access" disabled>{t('accountAccess')}</Dropdown.Item>
        <Dropdown.Divider></Dropdown.Divider>
        <Dropdown.Item onClick={()=>i18n.changeLanguage('en')} >EN</Dropdown.Item>
        <Dropdown.Item onClick={()=>i18n.changeLanguage('hr')}>HR</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SettingsDropdown;
